/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { InsertClassroomUserRequestViewModel } from "../types/InsertClassroomUserRequestViewModel.ts";
import { eClassRoomUserTypeSchema } from "./eClassRoomUserTypeSchema.ts";

export const insertClassroomUserRequestViewModelSchema = z.object({
  personId: z.optional(z.number().int()),
  classroomUserType: z.optional(
    z
      .lazy(() => eClassRoomUserTypeSchema)
      .describe("1 = Monitor | 2 = Instructor | 3 = Student | 4 = Viewer | "),
  ),
}) as unknown as ToZod<InsertClassroomUserRequestViewModel>;
